import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'

/**
 * Gets the marco agreements items.
 */
export const getMarcoAgreementItems = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/reajusteextraordinario/convenioMarco`)
})
